export enum SnackbarMode {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Alert = 'alert',
  Light = 'light'
}
